export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-1.430f98a1.png";